
import Vue from "vue";
import CoownersList, {
  OwnershipType,
} from "../../common/CoownersList.vue";
import Datepicker from "../../common/inputs/DatepickerFormatted.vue";
import PaginationSelect from "@/components/common/PaginationSelect.vue";

import dogService from "@/services/admin/dogService";

import { UserInfo } from "@/types/User";
import { MetaNames } from "@/constants";
import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";

export default Vue.extend({
  name: "DogList",
  components: {
    CoownersList,
    Datepicker,
    PaginationSelect
  },
  props: {
    useForSelection: { type: Boolean},
    onRowSelected: { type: Function },
  },
  data: function() {
    return {
      title: MetaNames.AdminDogs,
      loading: false,
      isError: false,
      errorMessage: "",
      paginatedResponse: {} as PaginatedResponse<object>,
      searchParams: {
        dogId: "",
        name: "",
        isASCA: null as any,
        damName: "",
        sireName: "",
        ascending: false,
        ownerName: "",
        whelpingDateFrom: "",
        whelpingDateTo: "",
      },
      options: {} as PaginationOptions,
      headers: [
        { text: "", align: "left", value: "dogId", width: "25%" },
        { text: "", align: "left", value: "litterId", width: "25%" },
        { text: "", align: "center", value: "whelpingDate", width: "15%" },
        { text: "", align: "left", value: "owners",width: "25%" },
        { text: "", align: "left", value: "isAustralianShepherd", width: "5%"},
        { text: "Registration date", align: "center", value: "registrationDate", width: "5%" },        
      ],
      footerProps: { 'items-per-page-options': [10, 20, 30, 40, 50, 100] },
      search: "",
      currentIsAscaIdx: 0,
      menu: false,
      dates: [] as string[],
    };
  },
  created: function() {
    this.load();
  },
  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    }
  },
  methods: {
    toggleAscaCheckbox: function() {
      var states = [null, true, false];
      var next = (++this.currentIsAscaIdx) % states.length;
      this.currentIsAscaIdx = next;
      this.searchParams.isASCA = states[next];
    },
    clearAllFilters: function() {
      this.options.page = 1;
      this.options.itemsPerPage = 10;
      this.dates = [];
      this.searchParams = {
        dogId: "",
        name:"",
        isASCA:null,
        damName:"",
        sireName:"",
        ascending: false,
        ownerName: "",
        whelpingDateFrom: "",
        whelpingDateTo: "",
      };
    },
    updateDates: function (val: any, key: string) {
      (this as any).searchParams[key] = val.date;
    },
    updateDateSearch: async function(val: any, key: string) {
      await this.updateDates(val, key);
      this.applyFilter();
    },
    load: async function () {
      this.loading = true;

      const {
        page,
        itemsPerPage,
      } = this.options;

      try {
        const response = await dogService.getDogsList({
          ...this.options,
          page: (page ?? 1) - 1,
          itemsPerPage: itemsPerPage ?? 10
        }, this.searchParams);

        this.loading = false;
        this.paginatedResponse = response;
      } catch (ex: any) {
        console.log(ex.response.data.errors)

        this.loading = false;
        this.isError = true;
        
        const descriptiveMessage = ex.response.data.errors
          ? `Error(s): ${Object.values(ex.response.data.errors).join(" & ")}`
          : null

        this.errorMessage = descriptiveMessage ?? ex.message ?? "Unknown error occurred when retrieving data.";
      }
    },
    applyFilter() {
      this.options.page = 1;
      this.options.itemsPerPage = 10;

      this.load();
    }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    dogOwnershipType: function() {
      return OwnershipType.Dog;
    },
  },
});
